// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RSKK","right":"styles_right__3S0aI"};